export default __webpack_public_path__ + "static/media/laundry1-afterA-1920w.2fad68ea.png";